import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HeaderMenu from "./HeaderMenu.vue";
import HeaderSchool from "./HeaderSchool.vue";
import HeaderSearch from "./HeaderSearch.vue";
export default {
  name: "Header",
  components: {
    HeaderMenu: HeaderMenu,
    HeaderSchool: HeaderSchool,
    HeaderSearch: HeaderSearch
  },
  data: function data() {
    return {
      navigates: [],
      topFiveNavigates: [],
      showSearch: false,
      headerStyle: "",
      examDays: '--'
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.setHeaderCss(route.name);
      },
      // 深度观察监听
      deep: true
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.$store.state.token) {
                this.$store.dispatch("refreshMessageState");
              }

              this.setHeaderCss(this.$route.name);
              this.getExamDays();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  computed: {
    bannerList: function bannerList() {
      return this.$store.state.indexData.bannerList;
    },
    iconUrl: function iconUrl() {
      return this.$store.state.commonSetting.not_vip_icon;
    }
  },
  methods: {
    getExamDays: function () {
      var _getExamDays = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.get('/api/app/kaoyan_time');

              case 2:
                res = _context2.sent;
                this.examDays = this.daysUntil(res.postgraduate_set_time);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getExamDays() {
        return _getExamDays.apply(this, arguments);
      }

      return getExamDays;
    }(),
    daysUntil: function daysUntil(fixedDate) {
      if (fixedDate == '' || !fixedDate || fixedDate == null) {
        return '--';
      } // 将字符串日期转换为日期对象


      var targetDate = new Date(fixedDate); // 获取今天的日期

      var today = new Date(); // 将日期转换为毫秒数

      var oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
      // 计算两个日期之间的差异（以毫秒为单位）

      var diff = targetDate - today; // 将差异转换为天数

      var daysLeft = Math.ceil(diff / oneDay);
      return daysLeft < 0 ? 0 : daysLeft;
    },
    handleScroll: function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      if (this.$route.name == "Index") {
        if (scrollTop > 50) {
          this.headerStyle = "headerIndex headerWithBack";
        } else if (this.bannerList && this.bannerList.length > 0) {
          this.headerStyle = "headerIndex headerWithBack";
        }

        this.$forceUpdate();
      }
    },
    setHeaderCss: function setHeaderCss(name) {
      if (name == "Index" && this.bannerList && this.bannerList.length > 0) {
        this.headerStyle = "headerIndex headerWithBack";
      } else {
        this.headerStyle = "";
      }

      if (this.$store.state.indexData.bannerList.length == 0) {
        this.headerStyle = "headerIndex headerWithBack";
      }

      this.$forceUpdate();
    },
    //判断会员是否过期
    getIsExpire: function getIsExpire(time) {
      if (time) {
        var now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳

        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }

      return false;
    },
    onStudentMenu: function onStudentMenu(command) {
      switch (command) {
        case "center":
          this.$router.push({
            name: "MemberCalendar"
          });
          break;

        case "logout":
          this.$store.commit("logout"); //this.$router.push({ name: "Course" });

          this.$router.push({
            name: "Index"
          });
          break;
      }
    },
    onSearchBtnClick: function onSearchBtnClick() {
      this.$router.push({
        name: "SearchResult"
      }); //this.showSearch = true;
    },
    handleResize: function handleResize() {
      if (!this.$refs.main) {
        return;
      }

      var mainWidth = this.$refs.main.offsetWidth;

      if (mainWidth == 1200) {
        return;
      }

      var width = document.documentElement.clientWidth;
      var leftWidth = this.$refs.left.offsetWidth;
      var rightWidth = this.$refs.right.offsetWidth;
      var surplus = width - leftWidth - rightWidth - 50 - 17;
      this.$refs.menu.setWidth(surplus);
    },
    onresetEl: function onresetEl() {
      var that = this;
      that.handleResize();
      window.addEventListener("scroll", that.handleScroll);
      window.addEventListener("resize", that.handleResize);
      window.$(".headerBar").hover(function () {
        that.headerStyle = "headerIndex headerWithBack";
        that.$forceUpdate();
      }, function () {
        that.handleScroll();
        that.$forceUpdate();
      });
    }
  },
  mounted: function mounted() {
    var that = this;

    if (this.$store.state.indexData.bannerList.length != 0) {
      that.$nextTick(function () {
        that.onresetEl("页面加载完");
      });
    }

    setTimeout(function () {
      that.onresetEl("重复一次");
    }, 1000);
  }
};